import { Injectable, Inject } from "@angular/core";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import * as _ from "lodash";

@Injectable()
export class AuthService {
  constructor() {}
  getTokenHeader(): HttpHeaders {
    if (this.getToken()) {
      return new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.getToken(),
        Accept: "application/json,*/*",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
      });
    } else {
      return new HttpHeaders({
        "Content-Type": "application/vnd.api+json",
        Accept: "*/*",
      });
    }
  }
  getToken() {
    const token: string = localStorage.getItem("gfrtoken");
    return token ? "Basic " + token : null;
    // return "Basic o64DTZqW8FOVnZ5fxBT7sBLldlZQsByblKpMZRYinRFdbdX0c0Y1B2sQ925Wh9Cm";
  }

  getTHJWTToken() {
      const thjwttoken: string = localStorage.getItem("thjwttoken");
    return thjwttoken ? "Bearer " + thjwttoken : null;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const contentType = "application/json";
    let headers = new HttpHeaders({
      Authorization: this.getToken(),
      "Content-Type": contentType,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "*",
      Accept: "application/json, text/plain, */*",
    });

    if (req.headers.has("searchType")) {
      headers = new HttpHeaders({
        Authorization: this.getToken(),
        "Content-Type": contentType,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        Accept: "application/json, text/plain, */*",
        searchType: req.headers.get("searchType"),
      });
    }

    const authReq = req.clone({ headers });
    return next.handle(authReq).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            console.log("recieved response");
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              console.log("recieved error");
            }
          }
        }
      )
    );
  }
}
